import instance from "@/utils/require.js"

// 登录页--用户登录
export function apiUserLogin(data = {}) {
	return instance({
		url: "/aim/api/v3/user/login",
		method: "post",
		data
	})
}

// 登录页--单点登录
export function apiSSOLogin(data = {}) {
	return instance({
		url: "/aim/api/v3/user/sso/login",
		method: "get",
		params: data
	})
}

// 工作交接
export function apiHandover(data = {}) {
	return instance({
		url: "/aim/api/v3/user/handover",
		method: "post",
		data
	})
}

// 首页--修改密码
export function apiUserChangePassword(data = {}) {
	return instance({
		url: "/aim/api/v3/user/change_password",
		method: "post",
		data
	})
}

// 首页--踢除其它登录
export function apiKickOutOtherLogins(data = {}) {
	return instance({
		url: "/aim/api/v3/user/kick_out_other_logins",
		method: "post",
		data
	})
}

// 首页--退出登录
export function apiUserLogout(data = {}) {
	return instance({
		url: "/aim/api/v3/user/logout",
		method: "post",
		data
	})
}


// 组织结构--组织结构表格
export function apiOrgTable(data = {}) {
	return instance({
		url: "/aim/api/v3/organization/tree_grid",
		method: "post",
		data
	})
}

// 组织结构--组织结构树图
export function apiOrgShow(data = {}) {
	return instance({
		url: "/aim/api/v3/organization/show",
		method: "post",
		data
	})
}

// 组织结构--添加组织结构
export function apiOrgAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/organization/add",
		method: "post",
		data
	})
}

// 组织结构--修改组织结构
export function apiOrgUpdate(data = {}) {
	return instance({
		url: "/aim/api/v3/organization/update",
		method: "post",
		data
	})
}

// 组织结构--禁用组织结构
export function apiOrgDisable(data = {}) {
	return instance({
		url: "/aim/api/v3/organization/disable",
		method: "post",
		data
	})
}

// 组织结构--启用组织结构
export function apiOrgEnable(data = {}) {
	return instance({
		url: "/aim/api/v3/organization/enable",
		method: "post",
		data
	})
}

// 组织结构--上移组织结构
export function apiOrgMoveUp(data = {}) {
	return instance({
		url: "/aim/api/v3/organization/move_up",
		method: "post",
		data
	})
}

// 组织结构--下移组织结构
export function apiOrgMoveDown(data = {}) {
	return instance({
		url: "/aim/api/v3/organization/move_down",
		method: "post",
		data
	})
}

// 组织结构--组织结构类别联级下拉
export function apiOrgTypeList(data = {}) {
	return instance({
		url: "/aim/api/v3/organization_type/list",
		method: "post",
		data
	})
}

// 组织结构--组织结构类别表格
export function apiOrgTypeTable(data = {}) {
	return instance({
		url: "/aim/api/v3/organization_type/tree_grid",
		method: "post",
		data
	})
}

// 组织结构--组织结构类别树图
export function apiOrgTypeShow(data = {}) {
	return instance({
		url: "/aim/api/v3/organization_type/show",
		method: "post",
		data
	})
}

// 组织结构--组织结构类别添加
export function apiOrgTypeAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/organization_type/add",
		method: "post",
		data
	})
}

// 组织结构--组织结构类别修改
export function apiOrgTypeUpdate(data = {}) {
	return instance({
		url: "/aim/api/v3/organization_type/update",
		method: "post",
		data
	})
}

// 组织结构--禁用组织结构类别
export function apiOrgTypeDisable(data = {}) {
	return instance({
		url: "/aim/api/v3/organization_type/disable",
		method: "post",
		data
	})
}

// 组织结构--启用组织结构类别
export function apiOrgTypeEnable(data = {}) {
	return instance({
		url: "/aim/api/v3/organization_type/enable",
		method: "post",
		data
	})
}

// 组织结构--上移组织结构类别
export function apiOrgTypeMoveUp(data = {}) {
	return instance({
		url: "/aim/api/v3/organization_type/move_up",
		method: "post",
		data
	})
}

// 组织结构--下移组织结构类别
export function apiOrgTypeMoveDown(data = {}) {
	return instance({
		url: "/aim/api/v3/organization_type/move_down",
		method: "post",
		data
	})
}

// 用户--表格分页查询
export function apiUserSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/user/search",
		method: "post",
		data
	})
}

// 用户--员工列表(在员工弹框中的表格使用)
export function apiUserList(data = {}) {
	return instance({
		url: "/aim/api/v3/user/list",
		method: "post",
		data
	})
}

// 用户--项目经理列表(在员工弹框中的表格使用)
export function apiUserPMList(data = {}) {
	return instance({
		url: "aim/api/v3/user/pm_list",
		method: "post",
		data
	})
}

// 用户--组织结构
export function apiOrgList(data = {}) {
	return instance({
		url: "/aim/api/v3/organization/list",
		method: "post",
		data
	})
}

// 用户--新增用户
export function apiUserAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/user/add",
		method: "post",
		data
	})
}

// 用户--修改用户
export function apiUserUpdate(data = {}) {
	return instance({
		url: "/aim/api/v3/user/update",
		method: "post",
		data
	})
}

// 用户--重置用户密码
export function apiUserResetPassword(data = {}) {
	return instance({
		url: "/aim/api/v3/user/reset_password",
		method: "post",
		data
	})
}

// 用户--禁用用户
export function apiUserDisable(data = {}) {
	return instance({
		url: "/aim/api/v3/user/disable",
		method: "post",
		data
	})
}

// 用户--启用用户
export function apiUserEnable(data = {}) {
	return instance({
		url: "/aim/api/v3/user/enable",
		method: "post",
		data
	})
}

// 用户--岗位列表
export function apiPositionList(data = {}) {
	return instance({
		url: "aim/api/v3/user/work_position/list",
		method: "post",
		data
	})
}

// 用户--岗位分类列表
export function apiPositionTypeList(data = {}) {
	return instance({
		url: "aim/api/v3/user/work_position_type/list",
		method: "post",
		data
	})
}

// 用户--岗位分页查询
export function apiPositionSearch(data = {}) {
	return instance({
		url: "aim/api/v3/user/work_position/search",
		method: "post",
		data
	})
}

// 用户--添加岗位
export function apiPositionAdd(data = {}) {
	return instance({
		url: "aim/api/v3/user/work_position/add",
		method: "post",
		data
	})
}

// 用户--修改岗位
export function apiPositionUpdate(data = {}) {
	return instance({
		url: "aim/api/v3/user/work_position/update",
		method: "post",
		data
	})
}

// 用户--上移岗位
export function apiPositionMoveUp(data = {}) {
	return instance({
		url: "aim/api/v3/user/work_position/move_up",
		method: "post",
		data
	})
}

// 用户--下移岗位
export function apiPositionMoveDown(data = {}) {
	return instance({
		url: "aim/api/v3/user/work_position/move_down",
		method: "post",
		data
	})
}

// 用户--删除岗位
export function apiPositionDelete(data = {}) {
	return instance({
		url: "aim/api/v3/user/work_position/delete",
		method: "post",
		data
	})
}

// 用户--岗位类别分页查询
export function apiPositionTypeSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/user/work_position_type/search",
		method: "post",
		data
	})
}

// 用户--添加岗位类别
export function apiPositionTypeAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/user/work_position_type/add",
		method: "post",
		data
	})
}

// 用户--修改岗位类别
export function apiPositionTypeUpdate(data = {}) {
	return instance({
		url: "/aim/api/v3/user/work_position_type/update",
		method: "post",
		data
	})
}

// 用户--上移岗位类别
export function apiPositionTypeMoveUp(data = {}) {
	return instance({
		url: "/aim/api/v3/user/work_position_type/move_up",
		method: "post",
		data
	})
}

// 用户--下移岗位类别
export function apiPositionTypeMoveDown(data = {}) {
	return instance({
		url: "/aim/api/v3/user/work_position_type/move_down",
		method: "post",
		data
	})
}

// 用户--删除岗位类别
export function apiPositionTypeDelete(data = {}) {
	return instance({
		url: "/aim/api/v3/user/work_position_type/delete",
		method: "post",
		data
	})
}